
import MonksHeaderWrapper from './MonksHeaderWrapper.vue'

export default {
  name: 'MonksHeader',

  components: {
    MonksHeaderWrapper,
  },

  props: {
    locale: {
      type: String,
      default: 'pt-br',
    },
    navigation: {
      type: Object,
      required: true,
    },
    topbarVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOverlayOpen: false,
      isMenuOpen: false,
    }
  },

  computed: {
    isPT() {
      return this.locale === 'pt-br'
    },
  },

  mounted() {
    window.addEventListener('dropdown:toggle', this.handleDropdownToggle)
  },

  beforeDestroy() {
    window.removeEventListener('dropdown:toggle', this.handleDropdownToggle)
  },

  methods: {
    handleDropdownToggle(event) {
      this.isOverlayOpen = event.detail.isActive
    },

    handleMenuToggle(isOpen) {
      this.isMenuOpen = isOpen
    },

    closeOverlay() {
      this.isOverlayOpen = false
    },
  },
}
